const BUTTON_VARIANTS = {
  NEUTRAL_SUBTLE: 'neutral-subtle',
  NEUTRAL_GHOST: 'neutral-ghost',
  PRIMARY_SOLID: 'primary-solid',
  PRIMARY_GHOST: 'primary-ghost',
  DANGER_SUBTLE: 'danger-subtle',
  DANGER_GHOST: 'danger-ghost',
  ON_BRAND_SOLID: 'on-brand-solid',
  ON_BRAND_SUBTLE: 'on-brand-subtle',
  ON_BRAND_GHOST: 'on-brand-ghost',
  ON_COLOR_SOLID: 'on-color-solid',
  ON_COLOR_SUBTLE: 'on-color-subtle',
  ON_COLOR_GHOST: 'on-color-ghost'
}

export default BUTTON_VARIANTS
